import { createFileRoute } from '@tanstack/react-router';
import { ReferencePage } from '../screens/developers/ReferencePage';

/** Public: the API reference, rendered from the published contract. */
export const Route = createFileRoute('/developers/reference')({
  component: ReferencePage,
});
